<main>

    <!-- section -->
    <div class="section">
        <div class="container">
            <div class="main_wrapper">

                
                
                <!-- calendar wrapper -->
                <div class="calendar_wrapper">
                    <div class="calendar_title">
                        <h3>Thank you!</h3>
                        <h4 style="color: #6A6A6A;">Your appointment has been confirmed. You will hear back from us shortly.</h4>
                    </div>
                    

                    <div class="powered_by">
                        <img src="assets/img/metanoa-logo.png" alt="">
                    </div>

                    <!-- confirm popup -->
                    

                </div>

            </div>
        </div>
    </div>

</main>